import { UsersState } from "@users/models/users.state";
import { ActionReducerMap, createFeatureSelector } from "@ngrx/store";
import { reducer as userDetailsReducer } from "@users/store/reducers/user-details.reducer";
import { reducer as userSearchReducer } from "@users/store/reducers/user-search.reducer";

export const reducers: ActionReducerMap<UsersState> = {
  userDetails: userDetailsReducer,
  userSearch: userSearchReducer
};

export const selectUsersState = createFeatureSelector<UsersState>("users");
